/**
 * Data mappers for converting GraphQL Rate types to legacy IRate interface
 */

import type { IRate } from '../../../../ts/interface/rental.interface';
import type { RateGraphQL } from './useRatesRelay';
import { buildRateOverview, formatRatePeriod } from '../../../../util/rateOverview';

// ============================================================================
// Rate Mappers
// ============================================================================

export { buildRateOverview, formatRatePeriod };

/**
 * Map GraphQL Rate to legacy IRate interface
 */
export function mapRateToIRate(rate: RateGraphQL): IRate {
  return {
    id: rate.oldId ?? rate.id,
    gid: rate.id,
    old_id: rate.oldId ?? '',
    name: rate.name,
    credit_card_hold: rate.creditCardHold ?? null,
    minimum_wallet_deposit: rate.minimumWalletDeposit ?? null,
    hidden: rate.hidden ?? false,
    max_rentals: rate.maxRentals ?? null,
    max_periods: rate.maxPeriods ?? null,
    active_on: rate.activeOn ?? '',
    base_rate: rate.baseRate ?? 0,
    price_per_period: rate.pricePerPeriod ?? 0,
    stringDuration: formatRatePeriod(rate.periodDuration ?? 0),
    period_duration: rate.periodDuration ?? 0,
    free_time: rate.freeTime ?? 0,
    overview: buildRateOverview(rate),
    archived: rate.archivedOn ?? null,
    reservation: false,
    membership_required: rate.membershipRequired ?? false,
  };
}

/**
 * Map array of GraphQL rates to IRate array
 */
export function mapRatesToIRates(rates: RateGraphQL[]): IRate[] {
  return rates.map(mapRateToIRate);
}
